export default {
    BASE_URL: '/app/version',
    api: [
        {
            name: 'list',
            desc: '版本管理列表',
            method: 'GET',
            path: '/list',
        },
        {
            name: 'upload',
            desc: '版本管理上传',
            method: 'POST',
            path: '/upload',
        },
        {
            name: 'detail',
            desc: '版本管理编辑获取详情',
            method: 'GET',
            path: '/detail/list',
        },
        {
            name: 'save',
            desc: '版本管理编辑保存',
            method: 'POST',
            path: '/save',
        },
        {
            name: 'updateStatus',
            desc: '版本管理编辑',
            method: 'POST',
            path: '/update/status',
        },
    ]
}


// WEBPACK FOOTER //
// ./src/api/apis/app/index.js